import React from "react";
import { CheckCircle2 } from "lucide-react";

export default function EvaluationSubmitSummary({ result }) {
    if (!result) return null;

    return (
        <div className="qr-result-card is-success">
            <div className="qr-result-head">
                <CheckCircle2 size={18} />
                <div>
                    <strong>Evaluation soumise</strong>
                    <p>{result.message}</p>
                </div>
            </div>
            <div className="qr-result-metrics">
                <span>Moyenne: {result.scoreApplicable ? result.averageScore : "--"}</span>
                <span>Statut: {result.status}</span>
            </div>
        </div>
    );
}
